export default __webpack_public_path__ + "static/media/transfer_internal.20f6c90f.png";